<template>
  <v-toolbar color="teal" fixed dark app>
    <v-toolbar-title class="ml-0 pl-3"> </v-toolbar-title>
    <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    <v-flex xs6>
      <div class="px-0">
        <h5>Usuario: {{ fullname }}</h5>
      </div>
      <div class="px-0">
        <h5>Tipo: {{ rol }}</h5><h5>Rol:  {{ perfil }}</h5>
      </div>
    </v-flex>
    <v-spacer></v-spacer>

    <v-btn class="btn-full" icon @click="handleFullScreen()">
      <v-icon>fullscreen</v-icon>
    </v-btn>
    <v-menu
      offset-y
      origin="center center"
      class="elelvation-1"
      :nudge-bottom="14"
      transition="scale-transition"
    >
    </v-menu>
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <v-btn class="btn-logo" icon large flat slot="activator">
        <div size="30px">
          <img class="logo-img" src="/static/avatar/logo.png" alt="Avatar" />
        </div>
      </v-btn>
      <v-list class="pa-0">
        <v-list-tile
          v-for="(item, index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>
<script>
import jwtDecode from "jwt-decode";
import Util from "@/util";

export default {
  name: "app-toolbar",
  components: {},
  props: {},
  data: () => ({
    fullname: "",
    rolInContract: "",
    rol: "",
    perfil: "",
    items: [
      {
        icon: "fullscreen_exit",
        href: "#",
        title: "Cerrar Sesion",
        click: () => {
          window.getApp.$emit("APP_LOGOUT");
        },
      },
    ],
  }),

  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
  },
  mounted() {
  },
  created() {
    
    let token = localStorage.getItem("token");
    const decodedToken = jwtDecode(token);
    const userDto = decodedToken.dto;
    const user = {
      id: userDto.id,
      nombre: userDto.nombre,
      apellido: userDto.apellido,
      tipo: userDto.tipo,
    };
    this.fullname = user.nombre + " " + user.apellido;
    this.rol = user.tipo;
    this.perfil= userDto.perfil.nombre;
    
    if (!this.fullname || this.fullname == undefined || this.fullname == "") {
      console.log("sin usuario activo => redirecciona a login");
      if (this.$route.path !== "/loginNew") {
        this.$router.replace({ path: "/loginNew" });
      }
    }
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
  },
};
</script>
